import { render } from "./article.vue?vue&type=template&id=18f31170&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"

import "./article.vue?vue&type=style&index=0&id=18f31170&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f31170"]])

export default __exports__